/* pi-image-text-slider.js — synchronized image + text track slider ====== */
(function () {
  if (customElements.get('pi-image-text-slider')) return;

  class PiImageTextSlider extends HTMLElement {
    constructor() {
      super();
      this.index = 0;
      this.count = 0;
      this.transitioning = false;
      this.resizeObserver = null;
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.mediaTrack = this.querySelector('.pi-its__media-track');
      this.contentTrack = this.querySelector('.pi-its__content-track');
      this.contentViewport = this.querySelector('.pi-its__content-viewport');
      this.mediaSlides = Array.from(this.querySelectorAll('.pi-its__media-slide'));
      this.contentSlides = Array.from(this.querySelectorAll('.pi-its__content-slide'));
      this.dots = Array.from(this.querySelectorAll('.pi-its__dot'));
      this.prevBtn = this.querySelector('.pi-its__nav--prev');
      this.nextBtn = this.querySelector('.pi-its__nav--next');

      this.count = this.mediaSlides.length;
      this.dataset.count = String(this.count);

      if (!this.mediaTrack || !this.contentTrack || this.count === 0) return;

      this.syncPosition(false);
      this.syncAria();
      this.syncDots();
      this.updateArrows();
      this.updateContentHeight();

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = parseInt(dot.getAttribute('data-index'), 10);
          if (!Number.isNaN(target)) this.goTo(target);
        });
      });

      if (this.count <= 1) return;

      this.addEventListener('keydown', this.onKeyDown);
      window.addEventListener('resize', this.onResize);

      if (typeof ResizeObserver !== 'undefined' && this.contentTrack) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.contentSlides.forEach((slide) => this.resizeObserver.observe(slide));
      }
    }

    disconnectedCallback() {
      this.removeEventListener('keydown', this.onKeyDown);
      window.removeEventListener('resize', this.onResize);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    onKeyDown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        if (this.index > 0) this.go(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        if (this.index < this.count - 1) this.go(1);
      }
    }

    onResize() {
      this.updateContentHeight();
    }

    go(direction) {
      if (this.transitioning || this.count <= 1) return;
      const nextIndex = this.index + direction;
      if (nextIndex < 0 || nextIndex >= this.count) return;
      this.goTo(nextIndex);
    }

    goTo(targetIndex) {
      if (
        this.transitioning ||
        this.count <= 1 ||
        targetIndex === this.index ||
        targetIndex < 0 ||
        targetIndex >= this.count
      ) {
        return;
      }

      this.transitioning = true;
      this.index = targetIndex;
      this.syncPosition(true);
      this.syncAria();
      this.syncDots();
      this.updateArrows();
      this.updateContentHeight();

      const duration = this.getSlideDuration();
      window.setTimeout(() => {
        this.transitioning = false;
      }, duration);
    }

    getSlideDuration() {
      const raw = getComputedStyle(this).getPropertyValue('--pi-its-slide-duration');
      return parseInt(String(raw).replace(/[^\d]/g, ''), 10) || 450;
    }

    syncPosition(animate) {
      const offset = -(this.index * 100);
      const transform = 'translate3d(' + offset + '%, 0, 0)';

      if (!animate) {
        this.mediaTrack.style.transition = 'none';
        this.contentTrack.style.transition = 'none';
      }

      this.mediaTrack.style.transform = transform;
      this.contentTrack.style.transform = transform;

      if (!animate) {
        void this.mediaTrack.offsetWidth;
        this.mediaTrack.style.transition = '';
        this.contentTrack.style.transition = '';
      }
    }

    syncAria() {
      this.contentSlides.forEach((slide, i) => {
        const active = i === this.index;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.tabIndex = active ? 0 : -1;
      });
    }

    syncDots() {
      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('pi-its__dot--active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    updateArrows() {
      if (this.prevBtn) {
        this.prevBtn.disabled = this.index <= 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = this.index >= this.count - 1;
      }
    }

    updateContentHeight() {
      if (!this.contentViewport || !this.contentSlides.length) return;

      const activeSlide = this.contentSlides[this.index];
      if (!activeSlide) return;

      this.contentViewport.style.height = activeSlide.offsetHeight + 'px';
    }
  }

  customElements.define('pi-image-text-slider', PiImageTextSlider);
})();
